import MeetingMessage from 'owa-service/lib/contract/MeetingMessage';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';
import MeetingResponseMessageType from 'owa-service/lib/contract/MeetingResponseMessageType';
import MeetingCancellationMessageType from 'owa-service/lib/contract/MeetingCancellationMessageType';

export default function isMeetingMessageForSeriesException(message: MeetingMessage): boolean {
    const meetingMessage = message as
        | MeetingRequestMessageType
        | MeetingResponseMessageType
        | MeetingCancellationMessageType;

    // CalendarItemType for the MeetingResponseMessage of occurrence is RecurringMaster, check RecurrenceId only
    return !!meetingMessage.RecurrenceId;
}
